import { render, staticRenderFns } from "./MercadoPago.vue?vue&type=template&id=afe70c0a&"
import script from "./MercadoPago.vue?vue&type=script&lang=ts&"
export * from "./MercadoPago.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports